import speechService from '@/services/speechService'
import notifications from '@/libs/notifications'

const state = {
  // ListProjects
  loadingSpeechProjects: true,
  speechProjects: [],
  totalSpeechProjects: 0,
  paginationProjects: {},

  // NewProject
  showNewProjectDialog: false,
  newProject: {
    name: '',
    description: ''
  },
  creatingProject: false,

  // Update Project
  showEditProjectDialog: false,
  updateProject: {
    id: '',
    name: '',
    description: ''
  },
  updatingProject: false,

  // Show Project
  selectedProject: {},
  loadingProjectAudios: false,
  loadingProjectInsights: false,
  projectInsights: {},
  projectAudios: [],
  totalProjectAudios: 0,
  paginationProjectAudios: {},

  // Stepper Upload Audios
  loadingNewSpeechStepper: false,

  // NLP
  freqIntentionData: [],
  totalFreqIntentionData: 0,
  projectNlpNetwork: {},

  // Show Audio Insights
  loadingAudioInsights: false,
  selectedAudioTranscript: {},
  projectAudioInsights: {},
  showAudioInsightsDialog: false
}
const mutations = {
  SET_LOADING_PROJECTS (state, status) {
    state.loadingSpeechProjects = status
  },
  SET_LOADING_PROJECT_INSIGHTS (state, status) {
    state.loadingProjectInsights = status
  },
  SET_LOADING_PROJECT_AUDIOS (state, status) {
    state.loadingProjectAudios = status
  },
  SET_LOADING_AUDIO_INSIGHTS (state, status) {
    state.loadingAudioInsights = status
  },
  SET_LOADING_UPLOAD_AUDIO_STEPPER (state, status) {
    state.loadingNewSpeechStepper = status
  },
  SET_CREATING_PROJECT (state, status) {
    state.creatingProject = status
  },
  SET_NEW_PROJECT (state, project) {
    state.newProject = project
  },
  SET_PROJECTS (state, projects) {
    state.speechProjects = projects
  },
  SET_PROJECT_AUDIOS (state, projectAudios) {
    state.projectAudios = projectAudios
  },
  SET_PROJECT_INSIGHTS (state, projectInsights) {
    state.projectInsights = projectInsights
  },
  SET_PROJECT_NLP_FREQ_INTENTION (state, freq) {
    state.freqIntentionData = freq
  },
  SET_TOTAL_PROJECT_NLP_FREQ_INTENTION (state, total) {
    state.totalFreqIntentionData = total
  },
  SET_PROJECT_NLP_NETWORK (state, NLP) {
    state.projectNlpNetwork = NLP
  },
  SET_SELECTED_PROJECT (state, project) {
    if (!project.id && project._id) project.id = project._id
    state.selectedProject = project
  },
  SET_SELECTED_AUDIO_TRANSCRIPT (state, audioTranscript) {
    state.selectedAudioTranscript = audioTranscript
  },
  SET_PROJECT_AUDIO_INSIGHTS (state, audioInsights) {
    state.projectAudioInsights = audioInsights
  },
  SET_UPDATING_PROJECT (state, status) {
    state.updatingProject = status
  },
  SET_UPDATE_PROJECT (state, project) {
    state.updateProject = project
  },
  SET_TOTAL_PROJECTS (state, total) {
    state.totalSpeechProjects = total
  },
  SET_TOTAL_PROJECT_AUDIOS (state, total) {
    state.totalProjectAudios = total
  },
  SET_PAGINATION_PROJECTS (state, pagination) {
    state.paginationProjects = pagination
  },
  TOGGLE_CREATE_PROJECT_DIALOG (state, status) {
    state.showNewProjectDialog = status
  },
  TOGGLE_UPDATE_PROJECT_DIALOG (state, status) {
    state.showEditProjectDialog = status
  },
  TOGGLE_AUDIO_INSIGHTS_DIALOG (state, status) {
    state.showAudioInsightsDialog = status
  },
  CLEAR_CREATE_PROJECT_FORM (state) {
    state.newProject = {
      name: '',
      description: ''
    }
  },
  CLEAR_EDIT_PROJECT_FORM (state) {
    state.updateProject = {
      name: '',
      description: ''
    }
  }
}

const actions = {
  getProjects (vuexContext) {
    vuexContext.commit('SET_LOADING_PROJECTS', true)
    speechService
      .getProjects(
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid)
      .then(response => {
        vuexContext.commit('SET_TOTAL_PROJECTS', response.count)
        vuexContext.commit('SET_PROJECTS', response.rows)
        vuexContext.commit('SET_LOADING_PROJECTS', false)
      })
      .catch(() => {
        vuexContext.commit('SET_PROJECTS', [])
        vuexContext.commit('SET_LOADING_PROJECTS', false)
      })
  },
  createProject (vuexContext) {
    vuexContext.commit('SET_CREATING_PROJECT', true)
    speechService
      .createProject(
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.newProject
      )
      .then(response => {
        // TODO: if response.success
        notifications.success('Proyecto creado correctamente')
        vuexContext.commit('SET_CREATING_PROJECT', false)
        vuexContext.commit('CLEAR_CREATE_PROJECT_FORM')
        vuexContext.commit('TOGGLE_CREATE_PROJECT_DIALOG', false)
        vuexContext.dispatch('getProjects')
      })
      .catch(error => {
        vuexContext.commit('SET_CREATING_PROJECT', false)
        notifications.error(error.message)
        console.log(error)
      })
  },
  updateProject (vuexContext) {
    vuexContext.commit('SET_UPDATING_PROJECT', true)
    speechService
      .updateProject(
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.updateProject
      )
      .then(response => {
        vuexContext.commit('SET_UPDATING_PROJECT', false)
        notifications.success('Proyecto actualizado')
        vuexContext.dispatch('getProjects')
        vuexContext.commit('TOGGLE_UPDATE_PROJECT_DIALOG', false)
        vuexContext.commit('CLEAR_EDIT_PROJECT_FORM')
      })
      .catch(error => {
        vuexContext.commit('SET_UPDATING_PROJECT', false)
        notifications.error(error.message)
      })
  },
  getProject (vuexContext) {
    vuexContext.commit('SET_LOADING_PROJECT_INSIGHTS', true)
    vuexContext.commit('SET_LOADING_PROJECT_AUDIOS', true)
    speechService
      .getProjectInsights(
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        { id: vuexContext.state.selectedProject.id }
      )
      .then(response => {
        const insights = response.insights
        vuexContext.commit('SET_PROJECT_INSIGHTS', insights)
        vuexContext.commit('SET_LOADING_PROJECT_INSIGHTS', false)
      })
      .catch(() => {
        vuexContext.commit('SET_PROJECT_INSIGHTS', {})
        vuexContext.commit('SET_LOADING_PROJECT_INSIGHTS', false)
      })
    speechService
      .getProjectAudios(
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        { id: vuexContext.state.selectedProject.id }
      )
      .then(response => {
        vuexContext.commit('SET_LOADING_PROJECT_AUDIOS', false)
        const audios = response.audiosTranscript
        vuexContext.commit('SET_PROJECT_AUDIOS', audios.rows)
        vuexContext.commit('SET_TOTAL_PROJECT_AUDIOS', audios.count)
      })
      .catch(() => {
        vuexContext.commit('SET_PROJECT_AUDIOS', [])
        vuexContext.commit('SET_LOADING_PROJECT_AUDIOS', false)
      })
  },
  getNLP (vuexContext) {
    speechService
      .getProjectNlpFreqIntention(
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        { id: vuexContext.state.selectedProject.id }
      )
      .then(response => {
        // console.log('response')
        // console.log(response)
        const freqIntention = response.freqIntention
        vuexContext.commit('SET_PROJECT_NLP_FREQ_INTENTION', freqIntention.rows)
        vuexContext.commit('SET_TOTAL_PROJECT_NLP_FREQ_INTENTION', freqIntention.count)
      })
      .catch(() => {
        vuexContext.commit('SET_PROJECT_NLP_FREQ_INTENTION', [])
        vuexContext.commit('SET_TOTAL_PROJECT_NLP_FREQ_INTENTION', 0)
      })
    speechService
      .getProjectNlpNetwork(
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        { id: vuexContext.state.selectedProject.id }
      )
      .then(response => {
        // console.log('response')
        // console.log(response)
        const nlpNetwork = response.network
        vuexContext.commit('SET_PROJECT_NLP_NETWORK', nlpNetwork)
      })
      .catch(() => {
        vuexContext.commit('SET_PROJECT_NLP_NETWORK', {})
      })
  },
  uploadAudios (vuexContext, { filesForm }) {
    vuexContext.commit('SET_LOADING_UPLOAD_AUDIO_STEPPER', true)
    speechService
      .uploadAudioPost(
        vuexContext.state.selectedProject.id,
        { filesForm }
      )
      .then(response => {
        // console.log('response')
        // console.log(response)
        vuexContext.commit('SET_LOADING_UPLOAD_AUDIO_STEPPER', false)
        vuexContext.dispatch('getProjects')
      })
      .catch(() => {
        vuexContext.commit('SET_LOADING_UPLOAD_AUDIO_STEPPER', false)
      })
  },
  getAudioInsights (vuexContext, index) {
    vuexContext.commit('SET_LOADING_AUDIO_INSIGHTS', true)
    speechService
      .getAudioInsights(
        // { fileName: vuexContext.state.selectedAudioTranscript.fileName }
        { fileName: 'JAYA_6CFHDRCJDD55PANJKUVH5TVSBO001233_2019-01-12_19-37-53_0' },
        index
      )
      .then(response => {
        // console.log('response')
        // console.log(response)
        vuexContext.commit('SET_LOADING_AUDIO_INSIGHTS', false)
        vuexContext.commit('SET_PROJECT_AUDIO_INSIGHTS', response)
      })
      .catch(() => {
        vuexContext.commit('SET_PROJECT_AUDIO_INSIGHTS', {})
        vuexContext.commit('SET_LOADING_AUDIO_INSIGHTS', false)
        vuexContext.commit('TOGGLE_AUDIO_INSIGHTS_DIALOG', false)
      })
  }
}

const getters = {
  selectedProject (state) {
    return state.selectedProject
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
